<template lang="html">
  <router-link to="/nswmath">Test Book</router-link>
</template>

<script lang="js">
export default {
  name: 'Home'
}
</script>

<style lang="scss" scoped>
</style>
